import { VNode } from 'vue';
import { Module } from 'vuex';
import { DefineMutations } from 'vuex-type-helper';
import { RootState } from '../index';

export interface ScrollAnchor {
    id: string;
    el: VNode;
    name: string;
}

export interface ModuleState {
    menuToggled: boolean;
    enquireFormToggled: boolean;
    covidFormShowed: boolean;
    enquireFormVisible: boolean;
    classList: string;
    scrollAnchors: ScrollAnchor[];
}

export interface ModuleMutations {
    toggleMenu: boolean;
    showEnquireForm: boolean;
    toggleEnquireForm: boolean;
    covidShowForm: boolean;
    addScrollAnchor: ScrollAnchor;
    removeScrollAnchor: ScrollAnchor;
}

const state: ModuleState = {
    menuToggled: false,
    enquireFormToggled: false,
    covidFormShowed: false,
    enquireFormVisible: false,
    classList: document.body.className,
    scrollAnchors: [],
};

const mutations: DefineMutations<ModuleMutations, ModuleState> = {
    toggleMenu(s: ModuleState, isToggled?: boolean) {
        s.menuToggled = typeof isToggled !== 'undefined' ? isToggled : !s.menuToggled;
    },
    showEnquireForm(s: ModuleState, isVisible?: boolean) {
        s.enquireFormVisible = typeof isVisible !== 'undefined' ? isVisible : !s.enquireFormVisible;
    },
    toggleEnquireForm(s: ModuleState, isToggled?: boolean) {
        s.enquireFormToggled = typeof isToggled !== 'undefined' ? isToggled : !s.enquireFormToggled;
    },
    covidShowForm(s: ModuleState, isVisible?: boolean) {
        s.covidFormShowed = typeof isVisible !== 'undefined' ? isVisible : !s.covidFormShowed;
    },
    addScrollAnchor(s: ModuleState, anchor: ScrollAnchor) {
        const exists = s.scrollAnchors.find((a) => a.id === anchor.id);
        if (!exists) {
            s.scrollAnchors.push(anchor);
        } else {
            console.warn('An anchor with this id already exists.');
        }
    },
    removeScrollAnchor(s: ModuleState, anchor: ScrollAnchor) {
        s.scrollAnchors = s.scrollAnchors.filter((a) => a.id !== anchor.id);
    },
};

const module: Module<ModuleState, RootState> = {
    namespaced: true,
    state,
    mutations,
};

export default module;
